// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://explorer.metis.io/address/0xB9FABd7500B2C6781c35Dd48d54f81fc2299D7AF
export const POOL_ADDRESSES_PROVIDER = '0xB9FABd7500B2C6781c35Dd48d54f81fc2299D7AF';

// IPool https://explorer.metis.io/address/0x90df02551bB792286e8D4f13E0e357b4Bf1D6a57
export const POOL = '0x90df02551bB792286e8D4f13E0e357b4Bf1D6a57';

// IPoolConfigurator https://explorer.metis.io/address/0x69FEE8F261E004453BE0800BC9039717528645A6
export const POOL_CONFIGURATOR = '0x69FEE8F261E004453BE0800BC9039717528645A6';

// IAaveOracle https://explorer.metis.io/address/0x38D36e85E47eA6ff0d18B0adF12E5fC8984A6f8e
export const ORACLE = '0x38D36e85E47eA6ff0d18B0adF12E5fC8984A6f8e';

// https://explorer.metis.io/address/0x2B5EA1604BAbb7B730120950Cb13951f3525828A
export const PRICE_ORACLE_SENTINEL = '0x2B5EA1604BAbb7B730120950Cb13951f3525828A';

// https://explorer.metis.io/address/0x6fD45D32375d5aDB8D76275A3932c740F03a8718
export const ACL_ADMIN = '0x6fD45D32375d5aDB8D76275A3932c740F03a8718';

// IACLManager https://explorer.metis.io/address/0xcDCb65fc657B701a5100a12eFB663978E7e8fFB8
export const ACL_MANAGER = '0xcDCb65fc657B701a5100a12eFB663978E7e8fFB8';

// IPoolDataProvider https://explorer.metis.io/address/0x602BeF1d4c381e5a29f0C562A310416A73D8Be19
export const AAVE_PROTOCOL_DATA_PROVIDER = '0x602BeF1d4c381e5a29f0C562A310416A73D8Be19';

// https://explorer.metis.io/address/0x56b814e2Ea4AE621B48FdC740850c3BbA81D8251
export const POOL_IMPL = '0x56b814e2Ea4AE621B48FdC740850c3BbA81D8251';

// https://explorer.metis.io/address/0xEBC4b627D8FC48d70BAd7DE09518677463581281
export const POOL_CONFIGURATOR_IMPL = '0xEBC4b627D8FC48d70BAd7DE09518677463581281';

// https://explorer.metis.io/address/0x30C1b8F0490fa0908863d6Cbd2E36400b4310A6B
export const DEFAULT_INCENTIVES_CONTROLLER = '0x30C1b8F0490fa0908863d6Cbd2E36400b4310A6B';

// https://explorer.metis.io/address/0xfDb2580A1ac4CDc67E4236738b28af59e2022Dd2
export const EMISSION_MANAGER = '0xfDb2580A1ac4CDc67E4236738b28af59e2022Dd2';

// ICollector https://explorer.metis.io/address/0xB5b64c7E00374e766272f8B442Cd261412D4b118
export const COLLECTOR = '0xB5b64c7E00374e766272f8B442Cd261412D4b118';

// https://explorer.metis.io/address/0x9eC6457cd8953ac68B5bd612FC64bF8D50Df3140
export const DEFAULT_A_TOKEN_IMPL = '0x9eC6457cd8953ac68B5bd612FC64bF8D50Df3140';

// https://explorer.metis.io/address/0x4b2ebE9FDFDecEF54Bf938dB462e8a184811D0a1
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0x4b2ebE9FDFDecEF54Bf938dB462e8a184811D0a1';

// https://explorer.metis.io/address/0x97CB9e81d480A2AB03299760654C1DDC0C16bE07
export const RISK_STEWARD = '0x97CB9e81d480A2AB03299760654C1DDC0C16bE07';

// https://explorer.metis.io/address/0x9f3A1B399A9074eBA63Dc4fc274bE2A2b2d80cB9
export const L2_ENCODER = '0x9f3A1B399A9074eBA63Dc4fc274bE2A2b2d80cB9';

// https://explorer.metis.io/address/0x6A7192c55E9298874e49675A63D5ebb11eD99a66
export const CONFIG_ENGINE = '0x6A7192c55E9298874e49675A63D5ebb11eD99a66';

// https://explorer.metis.io/address/0x9E7B73ffD9D2026F3ff4212c29E209E09C8A91F5
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0x9E7B73ffD9D2026F3ff4212c29E209E09C8A91F5';

// https://explorer.metis.io/address/0xE92cd6164CE7DC68e740765BC1f2a091B6CBc3e4
export const UI_INCENTIVE_DATA_PROVIDER = '0xE92cd6164CE7DC68e740765BC1f2a091B6CBc3e4';

// https://explorer.metis.io/address/0xE970Db949A75702bB5A280125742078cF39CE568
export const UI_POOL_DATA_PROVIDER = '0xE970Db949A75702bB5A280125742078cF39CE568';

// https://explorer.metis.io/address/0x1df710eb1E2FD9C21494aF2BFb1F210a4185885b
export const WALLET_BALANCE_PROVIDER = '0x1df710eb1E2FD9C21494aF2BFb1F210a4185885b';

// https://explorer.metis.io/address/0x9C62AdC332888F56998542415c38D7CDf3Ff7619
export const LEGACY_STATIC_A_TOKEN_FACTORY = '0x9C62AdC332888F56998542415c38D7CDf3Ff7619';

// https://explorer.metis.io/address/0x1bFFB297643dBD4D0F6A27F431CF878cE9175d00
export const DUST_BIN = '0x1bFFB297643dBD4D0F6A27F431CF878cE9175d00';

// https://explorer.metis.io/address/0x53d3c1B2d42578F56ef4c0142F19CDB54CE55040
export const CLINIC_STEWARD = '0x53d3c1B2d42578F56ef4c0142F19CDB54CE55040';

export const CHAIN_ID = 1088;
export const ASSETS = {
  mDAI: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0x4c078361FC9BbB78DF910800A991C7c3DD2F6ce0',
    A_TOKEN: '0x85ABAdDcae06efee2CB5F75f33b6471759eFDE24',
    V_TOKEN: '0x13Bd89aF338f3c7eAE9a75852fC2F1ca28B4DDbF',
    INTEREST_RATE_STRATEGY: '0x258625AfDe0073f5Bbce50C0305f4C23B16C7F3a',
    ORACLE: '0xf577E512687C83706ccfeD31C1939C75E8ea966F',
    STATIC_A_TOKEN: '0x66a2E4cff95BDE6403Ed5541B396aA0B171e5509',
  },
  Metis: {
    decimals: 18,
    id: 1,
    UNDERLYING: '0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000',
    A_TOKEN: '0x7314Ef2CA509490f65F52CC8FC9E0675C66390b8',
    V_TOKEN: '0x0110174183e13D5Ea59D7512226c5D5A47bA2c40',
    INTEREST_RATE_STRATEGY: '0x258625AfDe0073f5Bbce50C0305f4C23B16C7F3a',
    ORACLE: '0xD4a5Bb03B5D66d9bf81507379302Ac2C2DFDFa6D',
    STATIC_A_TOKEN: '0x5DE732A094A0ceF0eBFEcF0A916bDAB29650a784',
  },
  mUSDC: {
    decimals: 6,
    id: 2,
    UNDERLYING: '0xEA32A96608495e54156Ae48931A7c20f0dcc1a21',
    A_TOKEN: '0x885C8AEC5867571582545F894A5906971dB9bf27',
    V_TOKEN: '0x571171a7EF1e3c8c83d47EF1a50E225E9c351380',
    INTEREST_RATE_STRATEGY: '0x258625AfDe0073f5Bbce50C0305f4C23B16C7F3a',
    ORACLE: '0x0b9cA640284cf2636577703f785D5aEEc466BC56',
    STATIC_A_TOKEN: '0xb24451C231C6e6A60aC46f45E98a267caae898f4',
  },
  mUSDT: {
    decimals: 6,
    id: 3,
    UNDERLYING: '0xbB06DCA3AE6887fAbF931640f67cab3e3a16F4dC',
    A_TOKEN: '0xd9fa75D14c26720d5ce7eE2530793a823e8f07b9',
    V_TOKEN: '0x6B45DcE8aF4fE5Ab3bFCF030d8fB57718eAB54e5',
    INTEREST_RATE_STRATEGY: '0x258625AfDe0073f5Bbce50C0305f4C23B16C7F3a',
    ORACLE: '0x433636CB0136Cfd75145ccca608Bb548E6C037dE',
    STATIC_A_TOKEN: '0xAAea6F041425B813760dA201d08d46487034A266',
  },
  WETH: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0x420000000000000000000000000000000000000A',
    A_TOKEN: '0x8acAe35059C9aE27709028fF6689386a44c09f3a',
    V_TOKEN: '0x8Bb19e3DD277a73D4A95EE434F14cE4B92898421',
    INTEREST_RATE_STRATEGY: '0x258625AfDe0073f5Bbce50C0305f4C23B16C7F3a',
    ORACLE: '0x3BBe70e2F96c87aEce7F67A2b0178052f62E37fE',
    STATIC_A_TOKEN: '0x2f1606864d6322c54b50a1762D4a1ca67f42d23d',
  },
} as const;
export const E_MODES = {} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
